import { render, staticRenderFns } from "./UserInfoAddress.vue?vue&type=template&id=74308c24&scoped=true&"
import script from "./UserInfoAddress.vue?vue&type=script&lang=js&"
export * from "./UserInfoAddress.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoAddress.vue?vue&type=style&index=0&id=74308c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74308c24",
  null
  
)

export default component.exports